// extracted by mini-css-extract-plugin
export var body = "index-module--body--2FfBT";
export var categoryLoop = "index-module--categoryLoop--RJFhw";
export var choiceProduct = "index-module--choiceProduct--cSggq";
export var choiceProductCenter = "index-module--choiceProductCenter--bpsh8";
export var community = "index-module--community--EZWLl";
export var communityIcon = "index-module--communityIcon--63yPi";
export var contact_btn = "index-module--contact_btn--YobNV";
export var enterprise = "index-module--enterprise--SrJJG";
export var enterpriseIcon = "index-module--enterpriseIcon--rwJAo";
export var functionalParameter = "index-module--functionalParameter--UcMtS";
export var header = "index-module--header--942TB";
export var innerContent = "index-module--innerContent--t1CT-";
export var loop = "index-module--loop--sKuFG";
export var loopContent = "index-module--loopContent--IkfRK";
export var mainTitle = "index-module--mainTitle--PNhPC";
export var operate = "index-module--operate--BAGjc";
export var operateBtn = "index-module--operateBtn--bYl1R";
export var parameterContent = "index-module--parameterContent--oZbrQ";
export var parameterContentShow = "index-module--parameterContentShow--NqcOV";
export var parameterHeader = "index-module--parameterHeader--Ol-4w";
export var productCategory = "index-module--productCategory--cKBXV";
export var subTitle = "index-module--subTitle--dLGH0";
export var tidbcloud = "index-module--tidbcloud--ys0qW";
export var title = "index-module--title--ktiul";